import React, { forwardRef } from 'react';
import { useAccordion } from './Accordion';
import { useAccordionItem } from './AccordionItem';
const AccordionPanel = forwardRef(function AccordionPanel({ testId = 'store-accordion-panel', children, ...otherProps }, ref) {
    const { indices } = useAccordion();
    const { index, button, panel } = useAccordionItem();
    return (React.createElement("div", Object.assign({ ref: ref, id: panel, "aria-labelledby": button, role: "region", "data-accordion-panel": true, "data-testid": testId, hidden: !indices.has(index) }, otherProps), children));
});
export default AccordionPanel;
//# sourceMappingURL=AccordionPanel.js.map